//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const ODS_PROJECT = {
    color: ['#4bb4e6', '#50be87', '#ffb4e6', '#a885d8', '#ffd200'],
    backgroundColor: 'var(--bs-body-bg, transparent)',
    textStyle: {},
    title: {
        textStyle: {
            color: 'var(--bs-body-color, #000000)',
        },
        subtextStyle: {
            color: 'var(--bs-secondary-color, #666666)',
        },
    },
    line: {
        itemStyle: {
            borderWidth: 1,
        },
        lineStyle: {
            width: 3,
        },
        symbolSize: 0,
        symbol: 'emptyCircle',
        smooth: true,
    },
    radar: {
        itemStyle: {
            borderWidth: 1,
        },
        lineStyle: {
            width: 2,
        },
        symbolSize: 4,
        symbol: 'emptyCircle',
        smooth: false,
    },
    bar: {
        itemStyle: {
            barBorderWidth: '2',
            barBorderColor: 'transparent',
        },
    },
    pie: {
        itemStyle: {
            borderWidth: '2',
            borderColor: 'var(--bs-body-bg, #ffffff)',
        },
    },
    scatter: {
        itemStyle: {
            borderWidth: '2',
            borderColor: 'var(--bs-body-bg, #ffffff)',
        },
    },
    boxplot: {
        itemStyle: {
            borderWidth: '2',
            borderColor: 'var(--bs-body-bg, #ffffff)',
        },
    },
    parallel: {
        itemStyle: {
            borderWidth: '2',
            borderColor: 'var(--bs-body-bg, #ffffff)',
        },
    },
    sankey: {
        itemStyle: {
            borderWidth: '2',
            borderColor: 'var(--bs-body-bg, #ffffff)',
        },
    },
    funnel: {
        itemStyle: {
            borderWidth: '2',
            borderColor: 'var(--bs-body-bg, #ffffff)',
        },
    },
    gauge: {
        itemStyle: {
            borderWidth: '2',
            borderColor: 'var(--bs-body-bg, #ffffff)',
        },
    },
    candlestick: {
        itemStyle: {
            color: 'var(--bs-success, #32c832)',
            color0: 'var(--bs-danger, #cd3c14)',
            borderColor: 'var(--bs-success, #228722)',
            borderColor0: 'var(--bs-danger, #cd3c14)',
            borderWidth: 1,
        },
    },
    graph: {
        itemStyle: {
            borderWidth: '2',
            borderColor: 'var(--bs-body-bg, #ffffff)',
        },
        lineStyle: {
            width: 1,
            color: 'var(--bs-secondary-color, #666666)',
        },
        symbolSize: 4,
        symbol: 'emptyCircle',
        smooth: false,
        color: [],
        label: {
            color: 'var(--bs-body-color, #000000)',
        },
    },
    map: {
        itemStyle: {
            areaColor: 'var(--bs-secondary-bg, #eeeeee)',
            borderColor: 'var(--bs-secondary-color, #444444)',
            borderWidth: 0.5,
        },
        label: {
            color: 'var(--bs-body-color, #000000)',
        },
        emphasis: {
            itemStyle: {
                areaColor: 'rgba(var(--bs-warning-rgb, 255,215,0),0.8)',
                borderColor: 'var(--bs-secondary-color, #444444)',
                borderWidth: 1,
            },
            label: {
                color: 'var(--bs-black, rgb(100,0,0))',
            },
        },
    },
    geo: {
        itemStyle: {
            areaColor: 'var(--bs-secondary-bg, #eeeeee)',
            borderColor: 'var(--bs-secondary-color, #444444)',
            borderWidth: 0.5,
        },
        label: {
            color: 'var(--bs-body-color, #000000)',
        },
        emphasis: {
            itemStyle: {
                areaColor: 'rgba(var(--bs-warning-rgb, 255,215,0),0.8)',
                borderColor: 'var(--bs-secondary-color, #444444)',
                borderWidth: 1,
            },
            label: {
                color: 'var(--bs-black, rgb(100,0,0))',
            },
        },
    },
    categoryAxis: {
        axisLine: {
            show: true,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
        axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
                color: 'var(--bs-danger, #eb0909)',
            },
        },
        axisLabel: {
            show: true,
            color: 'var(--bs-body-color, #000000)',
        },
        splitLine: {
            show: false,
            lineStyle: {
                color: ['var(--bs-border-color-subtle, #cccccc)'],
            },
        },
        splitArea: {
            show: false,
            areaStyle: {
                color: ['var(--bs-body-bg, #ffffff)'],
            },
        },
    },
    valueAxis: {
        axisLine: {
            show: true,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
        axisTick: {
            show: false,
            alignWithLabel: true,
            lineStyle: {
                color: 'var(--secondary-color, #6E7079)',
            },
        },
        axisLabel: {
            show: true,
            color: 'var(--bs-body-color, #000000)',
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: ['var(--bs-border-color-subtle, #cccccc)'],
            },
        },
        splitArea: {
            show: false,
            areaStyle: {
                color: ['rgba(var(--bs-body-bg-rgb, 250,250,250),0.2)', 'rgba(var(--bs-tertiary-color-rgb, 210,219,238),0.2)'],
            },
        },
    },
    logAxis: {
        axisLine: {
            show: false,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
        axisTick: {
            show: false,
            alignWithLabel: true,
            lineStyle: {
                color: 'var(--bs-secondary-color, #6E7079)',
            },
        },
        axisLabel: {
            show: true,
            color: 'var(--bs-body-color, #000000)',
        },
        splitLine: {
            show: false,
            lineStyle: {
                color: ['var(--bs-border-color-subtle, #cccccc)'],
            },
        },
        splitArea: {
            show: false,
            areaStyle: {
                color: ['rgba(var(--bs-body-bg-rgb, 250,250,250),0.2)', 'rgba(var(--bs-tertiary-color-rgb, 210,219,238),0.2)'],
            },
        },
    },
    timeAxis: {
        axisLine: {
            show: true,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
        axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
            },
        },
        axisLabel: {
            show: true,
            color: 'var(--bs-body-color, #000000)',
        },
        splitLine: {
            show: false,
            lineStyle: {
                color: ['var(--bs-border-color-subtle, #cccccc)'],
            },
        },
        splitArea: {
            show: false,
            areaStyle: {
                color: ['rgba(var(--bs-body-bg-rgb, 250,250,250),0.2)', 'rgba(var(--bs-tertiary-color-rgb, 210,219,238),0.2)'],
            },
        },
    },
    toolbox: {
        iconStyle: {
            borderColor: 'var(--bs-secondary-color, #999999)',
        },
        emphasis: {
            iconStyle: {
                borderColor: 'var(--bs-body-color, #666666)',
            },
        },
    },
    legend: {
        textStyle: {
            color: 'var(--bs-body-color, #333333)',
        },
    },
    tooltip: {
        backgroundColor: 'var(--ods-tooltip-background, var(--bs-body-bg, #ffffff))',
        borderColor: 'var(--ods-tooltip-border-color, var(--bs-body-color, #000000))',
        borderWidth: 1,
        padding: [8, 8],
        textStyle: {
            color: 'var(--ods-tooltip-text-color, var(--bs-body-color, #000000))',
            fontSize: 14,
        },
        extraCssText: 'border-radius: var(--ods-tooltip-border-radius, 0); box-shadow: var(--ods-tooltip-shadow, none);',
        axisPointer: {
            type: 'line',
            lineStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
                width: 1,
            },
            crossStyle: {
                color: 'var(--bs-border-color-subtle, #cccccc)',
                width: 1,
            },
        },
    },
    timeline: {
        lineStyle: {
            color: 'var(--bs-tertiary-bg, #dae1f5)',
            width: 2,
        },
        itemStyle: {
            color: 'var(--bs-secondary-bg, #a4b1d7)',
            borderWidth: 1,
        },
        controlStyle: {
            color: 'var(--bs-secondary-bg, #a4b1d7)',
            borderColor: 'var(--bs-secondary-bg, #a4b1d7)',
            borderWidth: 1,
        },
        checkpointStyle: {
            color: 'var(--bs-info, #316bf3)',
            borderColor: 'var(--bs-body-bg, #ffffff)',
        },
        label: {
            color: 'var(--bs-secondary-bg, #a4b1d7)',
        },
        emphasis: {
            itemStyle: {
                color: 'var(--bs-body-bg, #ffffff)',
            },
            controlStyle: {
                color: 'var(--bs-secondary-bg, #a4b1d7)',
                borderColor: 'var(--bs-secondary-bg, #a4b1d7)',
                borderWidth: 1,
            },
            label: {
                color: 'var(--bs-secondary-bg, #a4b1d7)',
            },
        },
    },
    visualMap: {
        inRange: {
            color: [
                'var(--ouds-charts-color-sequential-accent-1-tint-100, #d2ecf9)',
                'var(--ouds-charts-color-sequential-accent-1-tint-200, #a5daf3)',
                'var(--ouds-charts-color-sequential-accent-1-tint-300, #79c7ec)',
                'var(--ouds-charts-color-sequential-accent-1-tint-400, #4ab4e6)',
                'var(--ouds-charts-color-sequential-accent-1-tint-500, #1fa2e0)',
                'var(--ouds-charts-color-sequential-accent-1-tint-600, #1982b3)',
            ],
        },
    },
    markPoint: {
        label: {
            color: 'var(--bs-body-color, #000000)',
        },
        emphasis: {
            label: {
                color: 'var(--bs-body-color, #000000)',
            },
        },
    },
};
